import { RecurringShift } from "../recurringShift/recurringShift";

export interface PlannedWorkShiftQueryParameters {
    employeeGroupId?: string;
    employeeIds?: string[];
    vehicleGroupId?: string;
    vehicleIds?: string[];
    startDate: string;
    endDate: string;
    includeUnassigned: boolean;
}

export interface PlannedWorkShiftDto {
    id: string;
    rowId: string;
    employeeId: string | null;
    employeeName: string | null;
    vehicleId: string | null;
    vehicleName: string | null;
    routeId: string | null;
    routeName: string | null;
    startTime: string;
    endTime: string;
    label: string | null;
    comment: string | null;
    state: PlannedWorkShiftState;
    isTempInstance: boolean;
    isOverridenFromRecurrence?: boolean;
    isGeneratedFromRecurrence?: boolean;
    recurrence?: RecurringShift;
    effectiveDate: string | null;
    duration: number | null;
}

export interface PlannedWorkShiftSaveDto {
    id: string;
    rowId: string;
    employeeId: string | null;
    vehicleId: string | null;
    routeId: string | null;
    startTime: string;
    endTime: string;
    label: string | null;
    comment: string | null;
    recurrence?: RecurringShift;
    isTempInstance?: boolean;
    isOverridenFromRecurrence?: boolean;
    isGeneratedFromRecurrence?: boolean;
}

export interface PlannedWorkShiftUpdateStateDto {
    id: string;
    rowId: string;
    state: PlannedWorkShiftState;
}

export interface PlannedWorkShiftsPublishDto {
    shifts: PlannedWorkShiftPublishDto[];
    recurringShifts: PlannedWorkShiftCreateRecurringDto[];
    contextStartDate?: string | null;
    contextEndDate?: string | null;
    salaryPeriodId?: string | null;
}

export interface PlannedWorkShiftPublishDto {
    id: string;
    rowId: string;
}

export interface PlannedWorkShiftCreateRecurringDto {
    recurringShiftId: string;
    recurringShiftRowId: string;
    employeeId: string | null;
    vehicleId: string | null;
    routeId: string | null;
    startTime: string;
    endTime: string;
    label: string | null;
    comment: string | null;
}

export enum PlannedWorkShiftState {
    InPlanning = 0,
    Published = 1,
}
